import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import axios from 'axios';
import Cookies from 'js-cookie';
import { toast } from 'react-toastify';
import Navbar from '../Navbar';
import Menu_Items from '../Menu_Items';
import { FaMedium } from "react-icons/fa";
import Loader from '../Loader';
import { FaArrowRightLong, FaCaretUp } from "react-icons/fa6";
import { FaSortDown } from "react-icons/fa";

function Mapping() {
  const { id, int_id, Ex_id } = useParams();
  const [su_admin, setsu_admin] = useState(false)
  const [admin, setadmin] = useState(false)
  const [monitor, setmonitor] = useState(false);

  const [opentable, setopentable] = useState(0);

  const [loading, setloading] = useState(true)

  const [tables, settables] = useState([]);
  const [values, setvalues] = useState({});
  const [headers, setheaders] = useState({});

  const [headerMapping, setheaderMapping] = useState({});
  const [valueMapping, setvalueMapping] = useState({});
  const [selectedHeaders, setselectedHeaders] = useState({});


  const menus = [
    {
      name: 'Integrations',
      id,
    },
    {
      name: 'Out Bound',
      id,
      submenu: [{ name: 'Out Bound', id, int_id, Ex_id },
      { name: 'Conditions', id, int_id, Ex_id },
      { name: 'Linked Tables', id, int_id, Ex_id },
      { name: 'Mapping', id, int_id, Ex_id },
      { name: 'Merge Tables', id, int_id, Ex_id },
      ]
    },
    (su_admin || admin ? { name: 'Users', id } : { name: null, id })
  ];
  const get_level = () => {
    const level = Cookies.get("level");
    if (level === "Super Admin") {
      setsu_admin(true);
    }
    else if (level === 'Admin') {
      setadmin(true)
    }
    else {
      setmonitor(true)
    }

  };
  const getOutBound = async () => {
    await axios.get(`/out_bound/export_value/${Ex_id}`).then(res => {
      if (res.data.Result_Mapping) {
        const { headerMapping, valueMapping } = JSON.parse(res.data.Result_Mapping)
        setheaderMapping(headerMapping)
        setvalueMapping(valueMapping)
      }
      if (res.data.Result_Headers) {
        const data1 = res.data.Result_Headers
          ? (typeof res.data.Result_Headers === 'string'
            ? JSON.parse(res.data.Result_Headers)
            : res.data.Result_Headers)
          : {};
        setselectedHeaders(data1)
      }

    }).catch((err) => {
      toast.error("get out_bound error", {
        autoClose: 2000, // 2 seconds
      });
    });
  };
  const getResult = async () => {
    await axios.get(`/out_bound/result/${Ex_id}`).then((res) => {
      const data = res.data;
      const TableNames = Object.keys(data);
      const AllHeaders = {};
      TableNames.map((name) => {
        const names = data[name][0] ? Object.keys(data[name][0]) : [];
        AllHeaders[name] = names
        return true
      });
      settables(TableNames)
      setheaders(AllHeaders);
      setvalues(data);
      setloading(false);
    }).catch((err) => {
      toast.error("out_bound trigger error", {
        autoClose: 2000, // 2 seconds
      });
    });
  };
  useEffect(() => {
    get_level()
    getOutBound()
    getResult()
  }, []);
  return (
    <div className='container df fdc jb ac'>
      <Navbar />
      <div className='main_box df'>
        <Menu_Items menu={menus} />
        <div className='content df fdc ac of_h'>
          <div className='page_header df jb ac'>
            <div className='w90 h5 df ac'>
              <FaMedium className='page_icon db' />
              <p>Results</p>
            </div>
          </div>
          {
            loading ? <Loader /> : <div className='h75 w100 df'>
              <div className='h75 w50 df fdc ac l_teal'>
                <div className='h5 w100 df jc ac blue'>Headers</div>
                {
                  tables.map((table, index) => (
                    <div className='w90 green' key={index}>
                      <div className='h5 w100 df ac'>
                        <label>{table}</label>
                        <div className='h5 w20'>
                          {
                            opentable === index ? <FaCaretUp className='icon' onClick={() => setopentable(null)} /> : <FaSortDown className='icon' onClick={() => setopentable(index)} />
                          }
                        </div>
                      </div>
                    </div>
                  ))
                }
              </div>
              <div className='h75 w50 l_green'></div>
            </div>
          }
        </div>
      </div>
    </div >
  )
}

export default Mapping;